const patternConstant = {
    ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
    NUMERIC: /^[0-9]+$/,
    FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
    PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/
    ///^\d{0,2}+(\.\d{0,2})?$/
  }
  
export const subscriptionPlanFields=[
    {
        id: "planId",
        label: "Subscription",
        placeHolder: "select",
        type: "select",
        options: [],
        disabled: true
      },
      {
        id: "duration",
        label: "Frequency",
        placeHolder: "select",
        type: "select",
        options: ["5 Days Trial", "3 Months", "6 Months", "12 Months"],
      },
      {
        id: "term",
        label: "Term",
        placeHolder: "select",
        type: "daterange",
        disabled: true,
        readOnly: true,
        disablePast: true
      },
      {
        id: "renewsOn",
        label: "Renews On",
        placeHolder: "Enter action",
        type: "text",
        disabled: true
      },
      {
        id: "subscriptionCost",
        label: "Subscription Cost",
        placeHolder: "Enter subscription cost",
        type: "number",
        disabled: true
      },
      {
        id: "discount",
        label: "Discount",
        placeHolder: "Enter discount",
        type: "text",
        patternAllowed: patternConstant?.PERCENTAGE
      },
      {
        id: "amountPayable",
        label: "Amount Payable",
        placeHolder: "Enter payable amount",
        type: "number",
        disabled: true,
      },
      {
        id: "paymentMethod",
        label: "Payment Method",
        placeHolder: "select",
        type: "select",
        options: ["Go Cardless Subscription"],
      },
     
]
export const subscriptionUpgradePlanFields=[
    {
        id: "planId",
        label: "Subscription",
        placeHolder: "select",
        type: "select",
        options: [],
        disabled: true
      },
      {
        id: "duration",
        label: "Frequency",
        placeHolder: "select",
        type: "select",
        options: ["5 Days Trial", "3 Months", "6 Months", "12 Months"],
      },
      // {
      //   id: "term",
      //   label: "Term",
      //   placeHolder: "select",
      //   type: "daterange",
      //   disabled: true,
      //   readOnly: true,
      //   disablePast: true
      // },
      // {
      //   id: "renewsOn",
      //   label: "Renews On",
      //   placeHolder: "Enter action",
      //   type: "text",
      //   disabled: true
      // },
      {
        id: "subscriptionCost",
        label: "Subscription Cost",
        placeHolder: "Enter subscription cost",
        type: "number",
        disabled: true
      },
      {
        id: "discount",
        label: "Discount",
        placeHolder: "Enter discount",
        type: "text",
        patternAllowed: patternConstant?.PERCENTAGE
      },
      {
        id: "amountPayable",
        label: "Amount Payable",
        placeHolder: "Enter payable amount",
        type: "number",
        disabled: true,
      },
      {
        id: "paymentMethod",
        label: "Payment Method",
        placeHolder: "select",
        type: "select",
        options: ["Go Cardless Subscription"],
      },
      {
        id: "option",
        label: "Option",
        placeHolder: "select",
        type: "radio",
        radioOptions:[{label:"Refund",value:"REFUND"},{label:"Credit",value:"CREDIT"}],
        // radioOptions: ["REFUND", "CREDIT"],
        row: true,
        labelPlacement: "end"
      }
]